import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
import exportMethod from './export'
/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:49
* @route '/reports/daily-v1/print'
*/
export const print = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: print.url(options),
    method: 'get',
})

print.definition = {
    methods: ["get","head"],
    url: '/reports/daily-v1/print',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:49
* @route '/reports/daily-v1/print'
*/
print.url = (options?: RouteQueryOptions) => {
    return print.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:49
* @route '/reports/daily-v1/print'
*/
print.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: print.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:49
* @route '/reports/daily-v1/print'
*/
print.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: print.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:49
* @route '/reports/daily-v1/print'
*/
const printForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: print.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:49
* @route '/reports/daily-v1/print'
*/
printForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: print.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:49
* @route '/reports/daily-v1/print'
*/
printForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: print.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

print.form = printForm

const dailyV1 = {
    export: Object.assign(exportMethod, exportMethod),
    print: Object.assign(print, print),
}

export default dailyV1